
















import { defineComponent} from '@vue/composition-api'
import { useGetters, useState } from 'vuex-composition-helpers'

import ErrorMessagesComponent from '@/shared/components/ErrorMessages.vue'
import MessageComponent from '@/shared/components/Message.vue'
import FormSelectComponent from './FormSelectComponent.vue'

export default defineComponent({
    name: "StudySelectComponent",
    components: {
        ErrorMessagesComponent,
        MessageComponent,
        FormSelectComponent
    },
    setup: () => {
        const { loading, error } = useState('impersonation', [ 'loading', 'error' ])
        const { labels, hasStudies } = useGetters('impersonation', [ 'labels', 'hasStudies'])

        return {
            loading,
            error,
            hasStudies,
            labels
        }
    }
})
